module.exports = __webpack_public_path__ + "img/antes_despues_08.0c45281d.png";